/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {
  FETCH_GLOBAL_CATEGORIES_REQUEST,
  FETCH_GLOBAL_CATEGORIES_SUCCESS,
  FETCH_GLOBAL_CATEGORIES_FAILURE,
} from "./GlobalAdminCategoriesTypes";

const initialState = {
  loading: false,
  categories: [],
  error: "",
};

const globalAdminCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GLOBAL_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_GLOBAL_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    case FETCH_GLOBAL_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default globalAdminCategoriesReducer;
